module.exports = __webpack_public_path__ + "assets/e45a245b2f728ddbcedf1c17a398b465.png";